<template>
  <div class="h-auto ml-0 w-full mr-3 min-h-screen">
    <div v-if="selectedReport == 'all'" class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold">Reports</p>
      </div>
<!--      <div class="p-6 grid lg:grid-cols-4 grid-cols-1 gap-4">
        <router-link
          :to="{ name: 'reports', params: { type: report.route } }"
          class="border border-0.5 h-28 p-3 rounded-lg shadow hover:shadow-md flex flex-col justify-center"
          v-for="report in reports"
          :key="report.name"
        >
          <div class="flex gap-3 items-center justify-center">
            <img class="h-6" :src="report.icon" />
            <p class="font-medium">{{ report.name }}</p>
          </div>
          <p class="text-center text-sm mt-3">{{ report.desc }}</p>
        </router-link>
      </div>-->
      <iframe title="HR management mock-up" style="width: 100%; height: 100vh; border: none" src="https://app.powerbi.com/view?r=eyJrIjoiMDQxMzhmZGEtYmM2Yy00YmMzLTllNWEtYjFkODQ1NWMxYzAwIiwidCI6ImY0YjVkZGQzLTIzYzYtNGZhZS1iNTkwLTI0NzMzNDQ5ZWUyYSIsImMiOjh9" frameborder="0" allowFullScreen="true"></iframe>
    </div>
    <div
      @click="goBack"
      v-if="selectedReport != 'all'"
      class="flex cursor-pointer items-center gap-2 m-3 rounded-full w-24 px-1 py-1.5 justify-center text-sm bg-white"
    >
      <img class="h-4 object-contain" src="@/assets/icons/left.png" />
      <p>Back</p>
    </div>
<!--    <Headcount
      v-if="selectedReport == 'Headcount Report'"
      :key="HeadcountKey"
    ></Headcount>
    <Onboarding
      v-if="selectedReport == 'Onboarding'"
      :key="OnboardingKey"
    ></Onboarding>
    <Offboarding
      v-if="selectedReport == 'Offboarding'"
      :key="OffboardingKey"
    ></Offboarding>
    <TimeoffBalance
      v-if="selectedReport == 'Time Off Balance'"
      :key="TBKey"
    ></TimeoffBalance>
    <TimeoffSchedule
      v-if="selectedReport == 'Time Off Schedule'"
      :key="TSKey"
    ></TimeoffSchedule>
    <MonthlyTimekeeping
      v-if="selectedReport == 'Monthly Timekeeping'"
      :key="MTKey"
    ></MonthlyTimekeeping>
    <EmployeeDataReports
      v-if="selectedReport == 'Employee Data Reports'"
      :key="EDKey"
    ></EmployeeDataReports>
    <EmployeeTurnoverRate
      v-if="selectedReport == 'Employee Turnover Rate'"
      :key="ETKey"
    ></EmployeeTurnoverRate>-->

  </div>
</template>

<script>
/*import Headcount from "@/components/reports/headcount.vue";
import Onboarding from "@/components/reports/onboarding.vue";
import Offboarding from "@/components/reports/offboarding.vue";
import TimeoffBalance from "@/components/reports/timeoffBalance.vue";
import TimeoffSchedule from "@/components/reports/timeoffSchedule.vue";
import MonthlyTimekeeping from "@/components/reports/monthlyTimekeeping.vue";
import EmployeeDataReports from "@/components/reports/employeeDataReports.vue";
import EmployeeTurnoverRate from "@/components/reports/employeeTurnoverRate.vue";*/
export default {
  name: "Reports",
  components: {
    /*Headcount,
    Onboarding,
    Offboarding,
    TimeoffBalance,
    TimeoffSchedule,
    MonthlyTimekeeping,
    EmployeeDataReports,
    EmployeeTurnoverRate,*/
  },
  data() {
    return {
      selectedReport: "all",
      HeadcountKey: 0,
      OnboardingKey: 1,
      OffboardingKey: 2,
      TBKey: 3,
      TSKey: 4,
      MTKey: 5,
      EDKey: 6,
      ETKey: 7,
      reports: [
        {
          name: "Headcount Report",
          icon: require("@/assets/icons/tally.png"),
          desc: "Breakdown of all current employees",
          route: "headcount-report",
        },
        {
          name: "Onboarding",
          icon: require("@/assets/icons/user-add-c.png"),
          desc: "Onboarding employees by date",
          route: "onboarding",
        },
        {
          name: "Offboarding",
          icon: require("@/assets/icons/remove-user.png"),
          desc: "Offboarding employees by month",
          route: "offboarding",
        },
        {
          name: "Time Off Balance",
          icon: require("@/assets/icons/briefcase.png"),
          desc: "Overview of time balances",
          route: "time-off-balance",
        },
        {
          name: "Time Off Schedule",
          icon: require("@/assets/icons/calendar-c.png"),
          desc: "An Overview of time schedules",
          route: "time-off-schedule",
        },
        {
          name: "Monthly Timekeeping",
          icon: require("@/assets/icons/clock-c.png"),
          desc: "Overview monthly time off",
          route: "overview-monthly-time-off",
        },
        {
          name: "Employee Data Reports",
          icon: require("@/assets/icons/folder.png"),
          desc: "An Overview of employee information",
          route: "employee-Data-reports",
        },
        {
          name: "Employee Turnover Rate",
          icon: require("@/assets/icons/users-c.png"),
          desc: "An Overview of resigned employees over the active employees in the company",
          route: "employee-turnover-rate",
        },
      ],
    };
  },
  created() {
    this.reports.forEach((report) => {
      if (report.route == this.$route.params.type) {
        this.selectedReport = report.name;
      }
    });
  },
  watch: {
    $route(to) {
      this.reports.forEach((report) => {
        if (report.route == to.params.type) {
          this.selectedReport = report.name;
        }
      });
      switch (this.selectedReport) {
        case "Headcount Report":
          this.HeadcountKey++;
          break;
        case "Onboarding":
          this.OnboardingKey++;
          break;
        case "Offboarding":
          this.Offboarding++;
          break;
        case "Time Off Balance":
          this.TBKey++;
          break;
        case "Time Off Schedule":
          this.TSKey++;
          break;
        case "Monthly Timekeeping":
          this.MTKey++;
          break;
        case "Employee Data Reports":
          this.EDKey++;
          break;
        case "Employee Turnover Rate":
          this.ETKey++;
          break;
      }
    },
  },
  methods: {
    goBack() {
      this.selectedReport = "all";
      this.$router.push({
        name: "reports",
        params: { type: "all", company: this.getOrganization },
      });
    },
  },
};
</script>
